export function formatCpf(value: string): string {
	const cnpjCpf = value.replace(/\D/g, '');
	return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
}

export function formatTelefone(value: string): string {
	const telefone = value.replace(/\D/g, '');
	return telefone.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/g, '($1)$2 $3-$4');
}
